require('./payrollLoanDocumentActions.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

class PayrollLoanDocumentActions extends React.Component {
    constructor(props) {
        super(props);

        this.handlePrint = this.handlePrint.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
    }

    buildDownload() {
        const { download } = this.props;

        return download ? (
            <div className="payroll-loan-document-actions__button" onClick={this.handleDownload}>
                <i className="icon icon-descargar" />
            </div>
        ) : null;
    }

    buildPrint() {
        const { print } = this.props;

        return print ? (
            <div className="payroll-loan-document-actions__button" onClick={this.handlePrint}>
                <i className="icon icon-imprimir" />
            </div>
        ) : null;
    }

    handleDownload() {
        const { handlers } = this.props;

        if (handlers.handleDownload) {
            handlers.handleDownload();
        }
    }

    handlePrint() {
        const { handlers } = this.props;

        if (handlers.handlePrint) {
            handlers.handlePrint();
        }
    }

    render() {
        const downloadButton = this.buildDownload();
        const printButton = this.buildPrint();

        return (
            <div className="row payroll-loan-document-actions">
                <div className="col-xs-12">
                    {downloadButton}
                    {printButton}
                </div>
            </div>
        );
    }
}

PayrollLoanDocumentActions.propTypes = {
    print: PropTypes.bool,
    download: PropTypes.bool,
    handlers: PropTypes.object.isRequired
};

module.exports = PayrollLoanDocumentActions;